const getters = {
  pillsLeft: (state) => {
    const { posts, pills, highlightNumber } = state;
    return posts.length - highlightNumber - pills.length;
  },
};

export default getters;
